import * as React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Footer from "../components/footer.js"
import Header from "../components/header.js"
import Announcement from "../components/announcement.js"

import HeroImage from "../images/hero-image-navy.svg"
import ArrowBlue from "../images/arrow-blue.png"
import IconClick from "../images/icon-click-navy.svg"
import IconWatch from "../images/icon-watch-navy.svg"
import IconPhone from "../images/icon-phone-navy.svg"
import Pattern from "../images/pattern.png"
import Number1 from "../images/number-1.svg"
import Number2 from "../images/number-2.svg"
import Number3 from "../images/number-3.svg"
import Favicon from "../images/bordr-favicon.png"
import SocialShare from "../images/bordr-logo-social.jpg"

const price = "$150";
const fiscalRepPrice = "$150";

const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="shortcut icon" type="image/png" href={Favicon}/>
        <meta name="author" content="Bordr Team"></meta>
        <meta name="description" content="The easiest way to get a Portugal NIF (Número de Identificação Fiscal). Fill out our online form to get the process started today."></meta>
        {/* Open graph data */}
        <meta property="og:title" content="Bordr - Get your Portugal NIF Online" />
        <meta property="og:url" content="https://bordr.io" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="The easiest way to get a Portugal NIF (Número de Identificação Fiscal). Fill out our online form to get the process started today." />
        <meta property="og:image" content={SocialShare} />
        <meta property="fb:app_id" content="409286673692377" />
        <title>Bordr - Get your Portugal NIF Online</title>
        {/* iubenda popups */}
        <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
        {/* helpscout beacon */}
        <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
        <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
      </Helmet>
      <Announcement />
      {/*-- hero banner --*/}
      <section className="bg-light-blue-50 flex flex-col">
        <Header />
        {/*-- grid --*/}
        <div className="max-w-screen-xl mx-auto my-12 px-6 flex flex-col md:flex-row items-center md:items-end">
          {/*-- hero text --*/}
          <div className="md:mr-8 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-bold">The easiest way to get a Portugal NIF</h1>
            <h3 className="text-2xl mt-3">Order online and receive your NIF from the comfort of your living room.</h3>
            {/*-- button --*/}
            <div className="mt-8 mb-12"> 
              <Link to="/checkout-nif/" className="btn-blue">Order my NIF</Link>
            </div>
          </div>
          {/*-- hero image --*/}
          <div className="w-3/4 pt-6 md:pt-0">
            <img src={HeroImage} alt="man typing on computer"/>
          </div>              
        </div>  
      </section>
      {/*-- angle --*/}
      <section className="bg-angle bg-no-repeat bg-cover h-10-vw">
        <div className="max-w-screen-xl mx-auto px-6">
          <img src={ArrowBlue} alt="blue arrow" className="hidden md:inline-block -rotate-2 h-24 lg:h-32 ml-2"/>
        </div>
      </section>
      {/*-- value props --*/}
      <section className="xl:-mt-8 2xl:-mt-14">
        {/*-- 3 column layout --*/}
        <div className="max-w-screen-xl mx-auto mt-8 px-6">
          {/*-- heading text --*/}
          <div className="md:w-3/5">
            <h2 className="text-3xl font-bold">Getting a NIF in Portugal shouldn't be difficult</h2>
            <h4 className="text-xl mt-3">As someone relocating to Portugal, a Portuguese tax ID, also known as the Número de Identificação Fiscal (or NIF for short) is absolutely essential. Bordr is the NIF service that we wish we had when we moved to Portugal.</h4>
          </div>
          {/*-- 3 points --*/}
          <div className="flex flex-col md:flex-row mt-10 md:mt-8">
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconClick} alt="finger tapping icon" className="h-16 mb-4"/>
              <h5 className=" uppercase text-lg font-bold tracking-wider">Convenient</h5>
              <p className="text-base mt-1">Order your Portugal NIF using our simple online form. Our website works on all devices including smartphones, tablets, and computers.</p>
            </div>
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconWatch} alt="watch icon" className="h-16 mb-4"/>
              <h5 className=" uppercase text-lg font-bold tracking-wider">Fast</h5>
              <p className="text-base mt-1">Simply complete our online form to get the process started. You can expect to receive your Portugal NIF within 1 week.</p>
            </div>
            <div className="justify-start mb-10 md:mb-8 md:mr-10 md:w-1/3">
              <img src={IconPhone} alt="chat bubble on phone icon" className="h-16 mb-4"/>
              <h5 className=" uppercase text-lg font-bold tracking-wider">Reliable</h5>
              <p className="text-base mt-1">We'll keep you updated on every step of the process. If you have any questions, you can always reach out to us via chat or email.</p>
            </div>
          </div>
          {/*-- button --*/}
          <div className="mt-4 mb-12"> 
            <Link to="/checkout-nif/" className="btn-blue">Order my NIF</Link>
          </div>
        </div>
        {/*-- crosses --*/}
        <div className="max-w-screen-xl mx-auto px-6 flex flex-row justify-center">
          <img src={Pattern} alt="cross pattern" className="hidden md:block w-24"/>
        </div>
      </section>                        
      {/*-- how it works --*/}
      <section className="bg-light-blue-50 py-16 mt-8 md:-mt-10">
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col items-center">
          {/*-- heading text --*/}
          <div className="w-full md:w-3/4 text-center justify-start">
            <h2 className="text-3xl font-bold">How It Works</h2>
            <h4 className="text-xl mt-3">All you need is a scanned image of your passport, a proof of address, and a credit card to get started.</h4>
          </div>
          {/*-- 3 steps --*/}
          <div className="flex flex-col">
            <div className="flex flex-row items-center mt-10">
              <img src={Number1} alt="one" className="h-10 w-6 mr-4"/>
              <p className="text-base">Fill out our online order form</p>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number2} alt="two" className="h-10 w-6 mr-4"/>
              <p className="text-base">Complete payment of {price} USD</p>
            </div>
            <div className="flex flex-row items-center mt-10">
              <img src={Number3} alt="three" className="h-10 w-6 mr-4"/>
              <p className="text-base">Receive your Portugal NIF in via email</p>
            </div>
            {/*-- button --*/}
            <div className="mt-10 mb-6 text-center"> 
              <Link to="/checkout-nif/" className="btn-blue">Order my NIF</Link>
            </div>
          </div>
        </div>
      </section>
      {/*-- faq --*/}
      <section className="py-16">
        <div className="max-w-screen-xl mx-auto px-6 flex flex-col w-full md:w-3/4 text-center">
          {/*-- heading text --*/}
          <div>
            <h2 className="text-3xl font-bold">FAQs</h2>
          </div>
          {/*-- questions --*/}
          <div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">What is a NIF?</p>
              <p className="text-base mt-1">The NIF (Número de Identificação Fiscal) is your taxpayer identification number in Portugal. The NIF is required for a variety of everyday activities such as opening a bank account, getting a phone subscription, and signing up for health insurance. The NIF is sometimes referred to as the Número de Contribuinte.</p>
            </div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">Who will be my fiscal (or tax) representative?</p>
              <p className="text-base mt-1">We connect you with a Portuguese lawyer who will be your fiscal representative and request a NIF on your behalf.</p>
            </div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">What can I use as Proof of Address?</p>
              <p className="text-base mt-1">This can be a driver's license, or a recent bank statement / utility bill. </p>
            </div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">Does Bordr offer ongoing fiscal representation?</p>
              <p className="text-base mt-1">Yes, but our fiscal representation services are limited to acquiring your NIF and forwarding any messages from the tax office until you assign a new fiscal rep (charged at a rate of {fiscalRepPrice} USD per year). <a href="https://support.bordr.io/article/22-what-is-fiscal-representation-and-why-am-i-being-charged-for-it" className="link-blue">Learn more about fiscal representation here.</a></p>
            </div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">How do I get a NIF for my child?</p>
              <p className="text-base mt-1">Simply fill out the order form with your child's details. If your child is under 18 years old, both parents will need to sign the Power of Attorney. This is a document that is sent shortly after completing the online checkout process.</p>
            </div>
            <div className="mt-10">
              <p className="text-lg font-bold leading-tight">Which nationalities does Bordr support for the NIF service?</p>
              <p className="text-base mt-1">We now support all nationalities for our NIF service.</p>
            </div>
          </div>
          {/*-- button --*/}
          <div className="mt-10 mb-6 text-center"> 
            <Link to="/checkout-nif/" className="btn-blue">Order my NIF</Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  )
}

export default IndexPage
